var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 144,
    viewBox: "0 0 233 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 232,
    height: 143,
    rx: 4.5,
    stroke: "#D8D8D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.7432 57.4174L58 57.4224V82.1333H66.7432C70.4411 82.1333 73.7962 80.8656 76.1891 78.5678C78.5497 76.3005 79.8513 73.1779 79.8513 69.7736V69.7091C79.8513 66.3116 78.5497 63.2009 76.1857 60.9489C73.7945 58.6715 70.4411 57.4174 66.7432 57.4174ZM66.7432 60.9337C69.4755 60.9337 71.8225 61.8212 73.5264 63.4996C75.1386 65.0999 76.0261 67.3265 76.0261 69.7719V69.8398C76.0261 75.0057 72.2078 78.6153 66.7432 78.6221H61.7267L61.7233 60.9337H66.7432Z",
    fill: "#149E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1007 63.2319C88.5059 63.2319 86.1012 64.2468 84.3329 66.0915C82.5951 67.8988 81.6362 70.3121 81.6362 72.8865V72.9595C81.6362 78.3307 85.7652 82.5394 91.0345 82.5394C96.3633 82.5377 100.536 78.2967 100.536 72.8848V72.8186C100.536 70.2611 99.5894 67.8649 97.8686 66.0711C96.1138 64.24 93.7091 63.2319 91.1007 63.2319ZM95.2602 77.3328C94.1894 78.5122 92.7129 79.1605 91.1024 79.1605C87.8475 79.1605 85.2951 76.4028 85.2917 72.8848V72.8203C85.2917 69.2633 87.7609 66.5802 91.0328 66.5802C94.3132 66.5802 96.8826 69.3498 96.8826 72.8848V72.9595C96.8826 74.6277 96.3056 76.1805 95.2602 77.3328Z",
    fill: "#149E00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.478 63.2249C166.278 63.2249 164.523 63.9953 163.133 65.5753V63.5999H159.546V82.1284H163.133V71.593C163.133 68.6775 165.032 66.641 167.749 66.641C170.475 66.641 171.975 68.3279 171.975 71.3928V82.1301H175.563V70.7513C175.563 66.1794 172.783 63.2249 168.478 63.2249Z",
    fill: "#149E00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.554 63.3257C139.226 63.3257 137.355 63.7737 135.1 64.87L134.679 65.0737L135.792 68.1979L136.312 67.94C138.017 67.1084 139.553 66.7385 141.289 66.7385C144.256 66.7385 145.785 68.108 145.839 70.8097C144.458 70.455 143.088 70.2225 141.125 70.2225C138.83 70.2225 136.895 70.7605 135.528 71.777C134.056 72.875 133.279 74.4957 133.281 76.4626V76.5305C133.281 80.449 136.76 82.499 140.195 82.499C142.869 82.499 144.695 81.4095 145.839 80.3438V82.124H149.398V70.92C149.398 68.5781 148.744 66.7249 147.456 65.4131C146.1 64.0266 144.115 63.3257 141.554 63.3257ZM144.403 78.1715C143.446 78.9369 142.128 79.3578 140.69 79.3578C138.808 79.3578 136.902 78.3429 136.902 76.3998V76.3302C136.902 74.4567 138.577 73.3383 141.384 73.3383C143.285 73.3383 144.721 73.6421 145.878 73.9544V75.1779C145.878 76.3642 145.369 77.3994 144.403 78.1715Z",
    fill: "#149E00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M156.252 63.6H152.659V82.1285H156.252V63.6Z",
    fill: "#149E00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M154.456 56C153.022 56 151.854 57.1676 151.854 58.6016C151.854 60.0356 153.022 61.2015 154.456 61.2015C155.892 61.2015 157.059 60.0339 157.059 58.6016C157.058 57.1676 155.89 56 154.456 56Z",
    fill: "#149E00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M122.962 62.3704L116.803 66.4009L110.645 62.3704L106.161 65.3063V63.6075H102.696V82.1411H106.277V69.4403L110.645 66.5825L115.013 69.4403L115.015 82.1411H118.601V69.4403L122.962 66.5774L127.329 69.4369L127.33 82.1411H130.913L130.909 67.5871L122.962 62.3704Z",
    fill: "#149E00"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.a5f1d8a618f6a16b79c1f8487d3739b1.svg";
export { ForwardRef as ReactComponent };